import {EffectsModule} from "@ngrx/effects";
import {CommonModule} from "@angular/common";
import {StoreModule} from "@ngrx/store";
import {VoucherEffects} from "@core/store/voucher/voucher.effects";
import {NgModule} from "@angular/core";
import {voucherReducers} from "@core/store/voucher/voucher.reducers";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('voucher', voucherReducers),
        EffectsModule.forFeature([VoucherEffects]),
    ],
    providers: [VoucherEffects],
})
export class VoucherStoreModule {
}
